import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 30, className = "" }) {
    const reduced = useReducedMotion();
    if (reduced) return <div className={className}>{children}</div>;
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay, ease: [0.2, 0.6, 0.2, 1] }}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLines({ lines = [], className = "", delay = 0.1, stagger = 0.12 }) {
    const reduced = useReducedMotion();
    return (
        <h1 className={className} data-testid="hero-headline">
            {lines.map((ln, i) => (
                <span key={i} className="mask-line">
                    {reduced ? (
                        <span>{ln}</span>
                    ) : (
                        <motion.span
                            initial={{ y: "110%" }}
                            animate={{ y: 0 }}
                            transition={{ duration: 1.05, ease: [0.7, 0, 0.15, 1], delay: delay + i * stagger }}
                        >
                            {ln}
                        </motion.span>
                    )}
                </span>
            ))}
        </h1>
    );
}
